module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/mail-heart-08e976c0880d8794dd71d469d764eeb8.svg";